// CSS className
export const CSS_START_BTN = 'start_btn';
export const CSS_END_BTN = 'end_btn';
export const CSS_CLOSE_BTN = 'close_btn';
export const CSS_DIV_BTN = 'div_btn';
export const CSS_DIV_EDITOR_WRAP = 'div_editor_wrap';
export const CSS_BTN_CLEAR_ALL = 'btn_clear_all';
export const CSS_SELECTED_AREA = 'selected_area';
export const CSS_SHADES_AREA = 'shades_area';
export const CSS_DISABLED = 'disabled';
export const CSS_VOD_CTRL_CLOSE = 'vod_ctrl_close';
export const CSS_BTN_CUT_EDITOR = 'btn_cut_editor';
export const CSS_BTN_CUT_EDITOR_CLOSE = 'btn_cut_editor_close';
export const CSS_TIMELINE_PLAYHEAD = 'timeline_playhead';
